<div class="tabs">
  <div
    class="tab"
    *ngFor="let tab of tabs"
    (click)="selectionContent(tab?.value || '1')"
  >
    <div class="tab-element" [ngClass]="{ 'active-tab': view === tab.value }">
      <span class="truncate hidden md:block ml-2">
        {{ tab?.label }}
      </span>
    </div>
  </div>
</div>
